import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  overline: `Put your first party data to work`,
  heading: `Activate data + intelligence`,
  description: `Make your AI more precise, intelligent, and impactful with trusted customer data.`,
}
const link = {
  text: `Create a free account`,
  url: `/twilio-developer-plan/`,
}

const FORM_ID = `twilio-demo-form`

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledHeroBase variant="2Col" copyVariant="narrow">
        <StyledHeroCopy>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading tag="h1" variant="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledHeroCopy>
        <HeroRecipe.Contents>
          <HeroRecipe.Form>
            <DemoFormContainer data-hook="demoFormContainer">
              <DemoForm
                after={
                  <ButtonText
                    href={getAbsoluteUrl(link.url, pageConfig)}
                    tag="a"
                    size="medium"
                    iconEnd={ChevronRightIcon}
                  >
                    {link.text}
                  </ButtonText>
                }
                customFormIdentifier={FORM_ID}
                customTrackingType={FORM_ID}
              />
            </DemoFormContainer>
          </HeroRecipe.Form>
        </HeroRecipe.Contents>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    align-items: flex-start;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 24px;
    }
  }
`

const StyledHeroCopy = styled(HeroRecipe.Copy)`
  ${({ theme }) => theme.breakpoints.down(`xs`)} {
    text-align: left;
  }
`

const DemoFormContainer = styled.div``

export default Hero
